import { axiosInstance } from "./axiosInstance";

export const getWishlist = async () => {
    const response = await axiosInstance.get("/api/wishlist");
    return response.data;
};

export const checkWishlist = async (productId: number) => {
    const response = await axiosInstance.get(`/api/wishlist/check/${productId}`);
    return response.data; // true or false 반환
};

export const toggleWishlist = async (productId: number) => {
    const response = await axiosInstance.post(`/api/wishlist/toggle/${productId}`);
    return response.data; // 토글 후의 결과 (true/false) 반환
};